import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import CAE_casilla from './../../../img/cae_casilla.png';
import CAE_mesa_casilla from './../../../img/cae_mesaCasilla.png';
import Are_casillas from './../../../img/are_casilla.png'
import SIJE_movilCasilla from './../../../img/sije_movil_casilla.png'
import SIJE_movilIncidente from './../../../img/sije_movil_incidente.png'
import Representantes from './../../../img/representantes.png'
import Capturista from './../../../img/capturista.png'
import CatalogoSIJE from './../../../img/catalogoSIJE.png'
import Extractor from './../../../img/extractor.png'
import AccionesComunes from '../../AccionesComunes';

class ComoOperaSIJE extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("conoceSIJE");
        activeMenu.className += " active";
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Conoce el SIJE</span>
                        <span>¿Cómo opera el SIJE?</span>
                    </small>
                </div>
                {/* <Migajas /> */}
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">¿Cómo opera el SIJE?</h1>
                </div>
                <div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical">
                        <div>
                            <p>
                            El SIJE opera en cada una de las Juntas Distritales Ejecutivas. Las y los CAE recorren las casillas que les fueron asignadas, recopilan y transmiten al SIJE la información de cada una de ellas.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={CAE_casilla} alt="cae casilla" />
                    </div>
                </div>

                {/* <div className="row bordes">
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={Are_casillas} alt="casillas ARE" />
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical">
                        <p>
                            Los CAE tienen asignadas un número variable de casillas, las cuales se encuentran dentro de su <Link to="./Glosario#a">ARE (Área de Responsabilidad Electoral)</Link>.
                        </p>
                    </div>
                </div> */}

                <div className="row bordes">
                    <div className="col-sm-12 centrar-vertical">
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={SIJE_movilCasilla} alt="aplicaion SIJE" />
                    </div>
                        <div>
                            <p>
                                La transmisión se realiza a través de un sistema híbrido:
                            </p>
                            <ul>
                                <li>
                                Vía voz: Se transmite la información mediante llamada telefónica y se captura en las Salas del SIJE en cada distrito.
                                </li>
                               <li>
                               Vía datos: Se captura y transmite la información de forma directa a través de una aplicación móvil (app SIJE), instalada en los teléfonos celulares asignados a las y los CAE.
                               </li>
                            </ul>
                        
                        </div>
                    </div>
                </div>

                
                <div className="row bordes">
                    <div className="col-md-12  text-center">
                        <h2 className="tituloPagina">¿Qué información recopila el SIJE?</h2>
                    </div>
                    <div className="col-sm-12 centrar-vertical">
                            <ul class="col-md-6 col-sm-12">
                                <li>
                                    Avance en la hora de instalación de casillas electorales.
                                </li>
                                <li>
                                    Integración de las mesas directivas de casilla.
                                </li>
                                <li>
                                    Hora de inicio de la votación.
                                </li>
                                <li>
                                Presencia de representantes de partidos políticos y candidaturas independientes en las casillas durante su instalación, así como su asistencia a las casillas por tipo de nombramiento.                             </li>
                                <li>
                            	    Presencia de observadores/as electorales.
                                </li>
                                <li>
                                    Incidentes que, en su caso, se registren en las casillas electorales.
                                </li>
                            </ul>
                            <div className="col-md-6 col-sm-12 text-center">
                                <img src={Capturista} alt="capturista Sala SIJE" /> 
                        </div>
                    </div>
                </div>

                {/* <div className="row bordes">
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={Representantes} alt="representantes" />
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical">
                        <p>
                            La información recuperada durante el “Segundo reporte” detalla el tipo de nombramiento de los funcionarios de casilla, así el tipo de Representantes de Partido Político y Candidatura Independiente presentes.
                        </p>
                    </div>
                </div> */}

                {/* <div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical">
                        <div className="numerales">
                            <p>4</p>
                        </div>
                        <div>
                            <p>
                                El CAE debe reportar cualquier incidente presentado en la casilla, al hacerlo debe clasificarlo de acuerdo al “Catálogo de incidentes SIJE”.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={SIJE_movilIncidente} alt="incidente" />
                    </div>
                </div> */}

                {/* {<div className="row bordes">
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={CatalogoSIJE} alt="catalogo de incidentes" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <p>
                            Existen 37 diferentes incidentes, según el “Catálogo de incidentes SIJE” aprobado para el Proceso Electoral Local 2018 - 2019.
                        </p>
                        <p>
                            Dichos incidentes se clasifican según la etapa de la Jornada donde puedan presentarse:
                        </p>
                        <ul>
                            <li>Durante la instalación de casillas</li>
                            <li>Durante el desarrollo de la votación</li>
                            <li>Durante el cierre de la votación</li>
                            <li>Durante el escrutinio y cómputo</li>
                        </ul>
                    </div>
                </div>} */}

                {/* <div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical">
                        <div className="numerales">
                            <p>5</p>
                        </div>
                        <div>
                            <p>
                                Toda la información recibida se almacena en la base de datos del sistema. Mediante un extractor de datos se crean cortes de información actualizada cada 5 minutos.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 text-center">
                        <img src={Extractor} alt="extractor de datos SIJE" />
                    </div>
                </div> */}
            </div>
        )
    }
}

export default ComoOperaSIJE;